var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9976 0C6.37014 0 0.997559 5.37258 0.997559 12C0.997559 18.6274 6.37014 24 12.9976 24C19.625 24 24.9976 18.6274 24.9976 12C24.9976 5.37258 19.625 0 12.9976 0ZM18.2436 9.31153C18.2576 10.2064 18.1392 14.6809 13.8924 16.6198C9.64571 18.5587 6.43506 16.1425 6.43506 16.1425C8.8105 16.3662 10.3686 15.0239 10.3686 15.0239C8.44454 14.9419 7.88523 13.1521 7.88523 13.1521C8.57134 13.2714 9.04609 13.08 9.04609 13.08C6.89842 12.5034 6.95307 10.4153 6.95307 10.4153C7.56456 10.7782 8.10151 10.7135 8.10151 10.7135C6.11289 9.28172 7.32995 7.14891 7.32995 7.14891C9.56715 9.90816 12.9184 9.98513 12.9184 9.98513C12.8709 9.76377 12.8474 9.53793 12.8484 9.31153C12.8484 7.5218 14.4254 6.62691 15.5331 6.62691C16.6408 6.62691 17.4605 7.46213 17.4605 7.46213C18.3032 7.42463 19.2056 6.85059 19.2056 6.85059C18.8476 7.93941 18.0947 8.34211 18.0947 8.34211C18.777 8.26753 19.5603 7.92445 19.5603 7.92445C19.2956 8.50617 18.2436 9.31153 18.2436 9.31153Z",
    fill: "#A7A2B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7002c98e5454dbb7856bb8f4aa8affc8.svg";
export { ForwardRef as ReactComponent };